module.exports = __webpack_public_path__ + "static/media/man-and-wife.be3f482a.jpg";